import React from 'react'
import { FaTimes } from 'react-icons/fa/index';

interface Props {
    onHide: {() : void},
    style?: React.CSSProperties
    show?: boolean,
    title?: string | React.ReactNode
};
interface State { 
};

export default class Drawer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.onHide = this.onHide.bind(this);

    this.state = { };
  }

  componentDidMount() {
    if(this.props.show) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(preProps: Props) {
    if(this.props.show) {
      document.body.style.overflow = 'hidden';
    }
  }

  onHide() {
    document.body.style.overflow = 'initial';
    this.props.onHide();
  }

  render() {
    const { show, children, style, title } = this.props;

    return (
        <div className={("drawer" + (show ? " drawer-open" : " drawer-hidden"))}>
            <div className="drawer-background" onClick={this.onHide}>
            </div>
            <div className="drawer-body" style={{...style}}>
                <div className="drawer-body-header">
                    { title }
                    <div className="drawer-body-hide-button" onClick={this.onHide}><FaTimes/></div>
                </div>
                { children }
            </div>
        </div>
    );
  }
}